import { render, staticRenderFns } from "./ProductPriorityContent.vue?vue&type=template&id=60325bc2&scoped=true&"
import script from "./ProductPriorityContent.vue?vue&type=script&lang=ts&"
export * from "./ProductPriorityContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPriorityContent.vue?vue&type=style&index=0&id=60325bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60325bc2",
  null
  
)

export default component.exports